interface StatusInfo {
  key: string;
  description: string;
}

export const EMAIL_VALIDATION_STATUSES: StatusInfo[] = [
  {
    key: 'VALID',
    description: 'The email address exists and can receive emails. Safe to send.'
  },
  {
    key: 'CATCH_ALL',
    description: 'The email server accepts all emails regardless of whether the mailbox exists. Generally safe to send.'
  },
  {
    key: 'INVALID',
    description: 'The email address does not exist or cannot receive emails. Do not send.'
  },
  {
    key: 'ABUSE',
    description: 'Associated with abuse reports or complaints. Do not send.'
  },
  {
    key: 'SPAMTRAP',
    description: 'This is a spam trap address used to catch spammers. Do not send.'
  },
  {
    key: 'DO_NOT_MAIL',
    description: 'Should not be mailed (role-based, disposable, or flagged). Avoid sending.'
  },
  {
    key: 'DISPOSABLE',
    description: 'From a disposable/temporary email service. May expire soon.'
  },
  {
    key: 'UNKNOWN',
    description: 'The validation service could not determine the status. Proceed with caution.'
  }
];
